import React, { FC, ReactNode } from 'react'
import { Collapse, Typography } from 'antd'

const { Panel } = Collapse

interface AccordionProps {
	items: { title: string; content: ReactNode }[]
}

export const Accordion: FC<AccordionProps> = ({ items }) => {
	return (
		<Collapse accordion>
			{items.map(({ title, content }, index) => (
				<Panel
					header={<Typography.Text strong>{title}</Typography.Text>}
					key={index}
				>
					{content}
				</Panel>
			))}
		</Collapse>
	)
}
